function PurchaseFormFooter({selectedPlan, endDate}) {
    return (
        <div className="footer-description">
            <h6 className="legalities-stmt">
                Your account will be charged ${selectedPlan?.amount} {selectedPlan?.interval_length == 12 ? "annually " : "monthly "}
                starting {endDate}. You may cancel your plan any time from your account section to avoid charges.
            </h6>

            <h6 className="legalities-stmt">
                Read our{" "}
                <a target="_blank" href="https://indimoves.com/terms-of-use/">
                    Terms of Service
                </a>
                ,{" "}
                <a target="_blank" href="https://indimoves.com/privacy-policy/">
                    Privacy Policy
                </a>
                , and{" "}
                <a target="_blank" href="https://indimoves.com/membership-terms/">
                    Membership Terms
                </a>
            </h6>
        </div>
    );
}

export default PurchaseFormFooter;
